import { withAuthenticationRequired } from 'react-oidc-context';

export function ProtectedRoute({ component, ...args }) {
  const Component = withAuthenticationRequired(component, args);
  // eslint-disable-next-line react-hooks/static-components
  return <Component />;
}
